import { FC, useContext } from "react";
import styled from "styled-components";

import Button from "../common/Button";
import AuthorizationContext from "../context/Authorization";

const BonusAuth: FC = () => {
  const { setShow } = useContext(AuthorizationContext);

  return (
    <>
      <AuthButton onClick={() => setShow(true)}>
        <span>Авторизуйтесь</span>
      </AuthButton>
      <Text className="kabel">
        чтобы копить
        <br /> и списывать бонусы
      </Text>
      <HowTo href="/bonus-program#spend" target="_blank">
        Как списывать накопленные бонусы
      </HowTo>
    </>
  );
};

const AuthButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #fff;
  background-color: #76b532;
  box-shadow: 0px 12px 22px rgba(120, 184, 51, 0.312698);
  border-radius: 10px;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 30px;

  &:before {
    display: block;
    width: 12px;
    height: 18px;
    margin-right: 6px;
    background: url(/static/icons/lock.svg) no-repeat center;
    background-size: contain;
    content: "";
  }
`;

const Text = styled.p`
  margin: 0 0 9px;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
`;

const HowTo = styled.a`
  display: block;
  font-size: 12px;
  line-height: 14px;
  color: #78b833;
  text-align: center;
`;

export default BonusAuth;
